import React from 'react';
import { CovalentBalanceItem } from '@shared/types/frontend';
import SwapPortfolioBalance from '@/components/trade/mobile/SwapPortfolioBalance';
import { useSession } from '@/contexts/LitSessionProvider';
import SlidingModal from '@/components/home/mobile/SlidingModal';
interface Props {
  isOpen: boolean;
  onClose: () => void;
  fromAssets: CovalentBalanceItem[];
  setFromAssets: (_: CovalentBalanceItem[]) => void;
}
export default function SwapFromAssetSelect({
  isOpen,
  onClose,
  fromAssets,
  setFromAssets
}: Props) {
  const {
    PKP,
    connectedWalletAddress
  } = useSession();
  return <SlidingModal heightFit isOpen={isOpen} onClose={onClose} data-sentry-element="SlidingModal" data-sentry-component="SwapFromAssetSelect" data-sentry-source-file="SwapFromAssetSelectModal.tsx">
      <div className='bg-genius-indigo relative w-full'>
        <div>
          <div className='w-full mt-2'>
            <div className={`w-full overflow-auto no-scrollbar  `}>
              <SwapPortfolioBalance wallet={PKP?.additionalEthAddress || connectedWalletAddress} selectedInputAssets={fromAssets} setSelectedInputAssets={setFromAssets} confirm={onClose} data-sentry-element="SwapPortfolioBalance" data-sentry-source-file="SwapFromAssetSelectModal.tsx" />
            </div>
          </div>
        </div>
      </div>
    </SlidingModal>;
}